import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { ScopusIdChangeRequest } from '@/module/Dashboard/model/DashboardTypes';

import { Form, TextInputControl } from '@/core/components';

interface ScopusIdChangeFormProps {
  onClose: () => void;
  isSubmitting: boolean;

  onChange: (request: ScopusIdChangeRequest) => void;

  scopusId: string;
}

export const scopusIdChangeSchema = z.object({
  scopusId: z.string().min(3),
});

type ScopusIdChangeSchema = z.infer<typeof scopusIdChangeSchema>;

export function ScopusIdChangeForm(props: ScopusIdChangeFormProps) {
  const { onClose, isSubmitting, onChange, scopusId } = props;
  const { t } = useTranslation();
  const form = useForm<ScopusIdChangeSchema>({
    defaultValues: { scopusId },
    resolver: zodResolver(scopusIdChangeSchema),
  });

  return (
    <Modal
      opened
      onClose={onClose}
      title={t('scopus.changeScopusId')}
    >
      <FormProvider {...form}>
        <Form
          onSubmit={form.handleSubmit(onChange)}
          onCancel={onClose}
          title=""
          isSubmitting={isSubmitting}
        >
          <TextInputControl<ScopusIdChangeSchema>
            label={t('scopus.form.scopusId')}
            name="scopusId"
            isSubmitting={isSubmitting}
          />
        </Form>
      </FormProvider>
    </Modal>
  );
}
